module.exports = __webpack_public_path__ + "img/monet-opal-necklace.61e736fb.jpg";